var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank"},domProps:{"textContent":_vm._s(_vm.filename)},on:{"click":_vm.downloadResource}})}
var staticRenderFns = []

export { render, staticRenderFns }